import { Card } from "antd";
import React from "react";

const Marketplace = (props) => {
    return (
      <Card
        data-aos='zoom-in'
        data-aos-delay={props.delay}
        className='card-marketplace'
        title={<h3>{props.title}</h3>}
        hoverable
      >
        <div className='content'>
          <img src={props.image} width={100} height={100} alt='marketplace' />
          <p>
            Hay<span>Style</span>
          </p>
        </div>
      </Card>
    );
}

export default Marketplace;